module.exports = __webpack_public_path__ + "files/7a1d4327518eab8c5600f4fdc520efcd.woff2";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/open-sans-v13-latin-ext_latin_cyrillic-ext_greek-ext_greek_cyrillic_vietnamese-700.woff2
 ** module id = 961
 ** module chunks = 0
 **/